export interface IAppMedError {
    readonly title: string;
    readonly message: string;
    readonly errorType?: string;
    readonly errorCode?: string;
    readonly contextData?: Record<string, unknown>;
}

export class AppMedError implements IAppMedError {
    public readonly title: string;
    public readonly message: string;
    public readonly errorType: string | undefined;
    public readonly errorCode: string | undefined;
    public readonly contextData: Record<string, unknown> | undefined;
    public readonly httpStatusCode: number | undefined;

    constructor(
        title: string,
        message: string,
        errorType?: string,
        errorCode?: string,
        contextData?: Record<string, unknown>,
        httpStatusCode?: number,
    ) {
        // super(message);

        this.title = title;
        this.message = message;
        this.errorType = errorType;
        this.errorCode = errorCode;
        this.contextData = contextData;
        this.httpStatusCode = httpStatusCode;
    }

    public static fromApiResponse(json: any, httpStatusCode?: number) {
        // Handle email error response structure from backend
        const contextData: Record<string, unknown> = {};
        
        // For email errors, the backend sends ErrorCode and EmailAddress as top-level properties
        if (json.errorCode) 
            contextData.ErrorCode = json.errorCode;
        
        if (json.emailAddress) 
            contextData.EmailAddress = json.emailAddress;
        
        return new AppMedError(
            json.title ?? '',
            json.message ?? '',
            json.errorType,
            json.errorCode,
            Object.keys(contextData).length > 0 ? contextData : json.contextData,
            httpStatusCode,
        );
    }
}
